import * as Configuration from 'src/ajs-app/app.constants.js';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions';

export class AudienceService {
  constructor($http, $filter, DropdownItemsFactory, UserFactory, MetricsFactory, AsyncRequestFactory, AngularSitesService) {
    this.$http = $http;
    this.$filter = $filter;
    this.DropdownItemsFactory = DropdownItemsFactory;
    this.UserFactory = UserFactory;
    this.MetricsFactory = MetricsFactory;
    this.AsyncRequestFactory = AsyncRequestFactory;
    this.AngularSitesService = AngularSitesService;
  }

  dateFromObj(o) {
    return new Date(o.year, o.month, o.day);
  }
  dateToObj(d) {
    return {
      year: d.getFullYear(),
      month: d.getMonth(),
      day: d.getDate()
    };
  }
  dateRangeToString(range) {
    // date picker, no need dateTimezone
    return range.from && range.to
      ? this.$filter('date')(range.from) + ' - ' + this.$filter('date')(range.to)
      : '';
  }

  getUserExternalIds(companyId, data) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/audience/user-optin-ids', data);
  }

  getUsers(companyId, data) {
    return this.$http.post(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/audience/users', data);
  }

  createExport(companyId, data) {
    return this.AsyncRequestFactory.post(companyId, Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/audience/exports', data);
  }

  buildDropdownItems(sites, segments) {
    const loggedUser = this.UserFactory.getLoggedUser();
    const marketingSites = Object.keys(loggedUser.capabilities || {})
      .filter(siteId => loggedUser.capabilities[siteId]?.includes(CapabilityIdEnum.Marketing))
      .map(siteId => this.AngularSitesService.sitesV2Map.get(+siteId));
    return {
      'sites': this.DropdownItemsFactory.buildSiteItems(marketingSites),
      'segments': this.buildSegmentItems(segments),
    }
  }

  buildSegmentItems(segments) {
    return (segments || []).map(s => ({
      'id': s.id,
      'label': s.title,
    }));
  }

  // formats the from and to dates as expected by the audience backend
  formattedAudienceFilters(filters) {
    const result = angular.copy(filters);

    const formatDate = (dateRange) => {
      try {
        const from = dateRange.from;
        const to = dateRange.to;
        dateRange.from = from ? this.MetricsFactory.formatFromDateForDayRangeQuery(from) : null;
        dateRange.to = to ? this.MetricsFactory.formatToDateForDayRangeQuery(to) : null;
        return dateRange;
      } catch {
        return dateRange;
      }
    };

    result.dateRange = formatDate(result.dateRange);
    result.expireDateRange = formatDate(result.expireDateRange);

    return result;
  }


  static AudienceFactory($http, $filter, DropdownItemsFactory, UserFactory, MetricsFactory, AsyncRequestFactory, AngularSitesService) {
    return new AudienceService($http, $filter, DropdownItemsFactory, UserFactory, MetricsFactory, AsyncRequestFactory, AngularSitesService);
  }
}

AudienceService.AudienceFactory.$inject = ['$http', '$filter', 'DropdownItemsFactory', 'UserFactory', 'MetricsFactory', 'AsyncRequestFactory', 'AngularSitesService'];
